<template>
    <results>
        <!-- Results loader -->
        <div
            slot="loader"
            class="row"
        >
            <content-loader
                v-for="(item, index) in 6"
                :key="index"
                :height="440"
                :width="320"
                :speed="2"
                primaryColor="#f4f4f4"
                secondaryColor="#ecebeb"
                class="col-md-6 col-lg-4"
            >
                <rect x="0" y="0" rx="5" ry="5" width="320" height="320" />
                <rect x="32" y="352" rx="0" ry="0" width="119" height="16" />
                <rect x="218" y="352" rx="0" ry="0" width="70" height="16" />
                <rect x="32" y="400" rx="0" ry="0" width="170" height="16" />
            </content-loader>
        </div>

        <!-- Results -->
        <div
            slot="results"
            class="row"
        >
            <product-card
                v-for="(product, index) in results"
                :key="index"
                :product="product"
                class="col-md-6 col-lg-4 mb-3 mb-xl-4"
            />
        </div>

        <!-- Results empty -->
        <div
            slot="results-empty"
            class="search-result-item-empty"
        >
            <div>
                <p>{{ $t('category.no_results') }}</p>
            </div>
        </div>
    </results>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader';
    import { mapState } from 'vuex';
    import ProductCard from '@/_vue/components/product/card';
    import Results from '@/_vue/components/ui/results';

    export default {
        name: 'SearchResults',
        components: {
            ContentLoader,
            ProductCard,
            Results,
        },
        computed: {
            ...mapState('filters', {
                results: 'results',
            }),
        },
    };
</script>
